<template>
  <div class="alert-box" :class="type">
    <span class="close right clickable" v-on:click.once="close">&times;</span>
    <ul v-html="text"></ul>
  </div>
</template>

<script>
export default {
  name: 'AppNotice',
  props: {
    text: String,
    type: {
      type: String,
      validator: (value) => {
        return (['info', 'success', 'warning', 'error'].indexOf(value) !== -1)
      }
    },
    timestamp: {
      type: Date,
      default: () => new Date()
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    this.closeByTimeout()
  },
  methods: {
    close () {
      this.$emit('noticeClose', this.timestamp)
    },
    closeByTimeout () {
      if (this.delay > 0) {
        setTimeout(() => {
          this.close()
        }, this.delay)
      }
    }
  }
}
</script>

<style lang="scss">
.alert-box {
  opacity: 0.9;
  position: relative;
  margin: 1em;
  background: #F9F9F9;
  padding: 1em 1em 1em 2em;
  border-left: 4px solid #DDD;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.125);
  /* if fixed then */
  width: 98%;
  top: 0;
  left: 0;
  /* endif */

  .close {
    float: right;
    font-size: 2em;
  }

  ul {
    list-style-type: none;
  }
}

.alert-box.info {
  border-color: #0074D9;
}

.alert-box.info:before {
  content: "i";
  background-color: #0074D9;
}

.alert-box.success {
  border-color: #2ECC40;
}

.alert-box.success:before {
  content: "√";
  background-color: #2ECC40;
}

.alert-box.warning {
  border-color: #FFDC00;
}

.alert-box.warning:before {
  content: "!";
  background-color: #FFDC00;
}

.alert-box.error {
  border-color: #FF4136;
}

.alert-box.error:before {
  content: "X";
  background-color: #FF4136;
}

.alert-box:before {
  position: absolute;
  top: 50%;
  margin-top: -17px;
  left: -17px;
  background-color: #DDD;
  color: #FFF;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
/*  font-family: Georgia; */
  text-shadow: 1px 1px rgba(0, 0, 0, 0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppNotice.vue